import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = '/api';
const DOC: { [k: string]: string } = { invoice: 'Faktura', receipt: 'Paragon', label: 'Etykieta' };

// Panel "OK - CRM": zamowienie z modulu Zamowienia (OPENkontakt) po id zamowienia Allegro (externalId):
// numer OK, zmiana statusu, dokumenty, notatki i dodawanie notatki. Odpowiednik ApiloNotesPanel.
export default function OkCrmPanel({ externalId }: { externalId: string }) {
  const [d, setD] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [stSaving, setStSaving] = useState(false);
  const [view, setView] = useState<any>(null);

  // tak jak w module Zamowienia: etykieta -> okienko przegladarki na srodku (strona Pakowalni z przyciskiem Drukuj),
  // faktura / paragon -> okno podgladu w panelu
  const openDoc = (x: any) => {
    if (!x || !x.url) return;
    if (x.doc_type === 'label') {
      const W = 520, H = 740;
      const sx = (window.screenX != null ? window.screenX : (window as any).screenLeft) || 0;
      const sy = (window.screenY != null ? window.screenY : (window as any).screenTop) || 0;
      const ow = window.outerWidth || window.innerWidth, oh = window.outerHeight || window.innerHeight;
      const w = window.open(x.url, 'etykieta', 'popup,width=' + W + ',height=' + H + ',left=' + Math.max(0, Math.round(sx + (ow - W) / 2)) + ',top=' + Math.max(0, Math.round(sy + (oh - H) / 2)));
      if (w) { try { w.focus(); } catch (e) { /* ignore */ } return; }
    }
    setView(x);
  };

  const load = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      const r = await axios.get(`${API}/ok-crm/order`, { params: { external_id: externalId } });
      setD(r.data);
    } catch (e: any) {
      const st = e && e.response && e.response.status;
      setErr(st === 403 ? 'Brak dostępu do modułu Zamówienia.' : 'Błąd pobierania zamówienia z OPENkontakt.');
    }
    setLoading(false);
  }, [externalId]);
  useEffect(() => { load(); }, [load]);

  const changeStatus = async (sid: number) => {
    if (!d || !d.id) return;
    setStSaving(true); setMsg('');
    try {
      await axios.patch(`${API}/orders/${d.id}/status`, { status_id: sid });
      setMsg('✓ Status zmieniony'); setTimeout(() => setMsg(''), 3000);
      await load();
    } catch (e: any) { setMsg('Nie udało się zmienić statusu'); }
    setStSaving(false);
  };
  const addNote = async () => {
    const t = draft.trim();
    if (!t || saving || !d || !d.id) return;
    setSaving(true); setMsg('');
    try {
      await axios.post(`${API}/orders/${d.id}/notes`, { comment: t });
      setDraft(''); setMsg('✓ Zapisano notatkę'); setTimeout(() => setMsg(''), 3000);
      await load();
    } catch (e: any) { setMsg('Nie udało się zapisać notatki'); }
    setSaving(false);
  };
  const fmt = (v: any) => { if (!v) return ''; try { return new Date(v).toLocaleString('pl-PL'); } catch (e) { return String(v); } };

  if (loading && !d) return <div style={{ padding: 14, fontSize: 13, color: '#6b7280', textAlign: 'center' }}>Ładowanie…</div>;
  if (err) return <div style={{ margin: 12, fontSize: 14, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '12px 14px' }}>{err}</div>;
  if (d && !d.found) return <div style={{ margin: 12, fontSize: 14, color: '#6b7280', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '12px 14px' }}>Tego zamówienia nie ma w module Zamówienia OPENkontakt.</div>;

  return (
    <div style={{ padding: 12 }}>
      {view ? (
        <div onClick={() => setView(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 10050, padding: '3vh 16px', overflowY: 'auto' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: view.doc_type === 'label' ? 560 : (view.doc_type === 'receipt' ? 360 : 900), padding: '12px 14px', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 15, flex: 1 }}>{DOC[view.doc_type] || 'Dokument'}{d && d.order_number ? ' · ' + d.order_number : ''}{view.number ? ' · ' + view.number : ''}</div>
              <a href={view.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#6b7280' }}>↗ nowa karta</a>
              <button onClick={() => setView(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280' }}>✕</button>
            </div>
            <iframe src={view.url} title="Podgląd dokumentu"
              style={{ width: '100%', height: view.doc_type === 'label' ? 'min(740px, 84vh)' : (view.doc_type === 'receipt' ? '34vh' : '84vh'), border: '1px solid #e5e7eb', borderRadius: 8, background: '#f9fafb' }} />
          </div>
        </div>
      ) : null}
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10, marginBottom: 12, paddingBottom: 10, borderBottom: '1px solid #dcfce7' }}>
        <span style={{ fontSize: 13 }}>Zamówienie: <b style={{ fontFamily: 'monospace', color: '#15803d' }}>{d.order_number}</b></span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 12, color: '#6b7280' }}>Status:</span>
          <select value={d.status_id ?? ''} onChange={(e) => changeStatus(Number(e.target.value))} disabled={stSaving}
            style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6, border: '1px solid #bbf7d0', background: '#fff', color: '#14532d', cursor: 'pointer' }}>
            <option value="" disabled>{stSaving ? 'Zapisuję…' : 'wybierz status…'}</option>
            {(d.statuses || []).map((s: any) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
        {(d.documents || []).length ? (d.documents || []).map((x: any, i: number) => (
          x.url
            ? <button key={i} onClick={() => openDoc(x)} style={{ fontSize: 12, color: '#14532d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '3px 8px', cursor: 'pointer' }}>📄 {DOC[x.doc_type] || x.doc_type}{x.number ? ' ' + x.number : ''}</button>
            : <span key={i} style={{ fontSize: 12, color: '#14532d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '3px 8px' }}>📄 {DOC[x.doc_type] || x.doc_type}{x.number ? ' ' + x.number : ''}</span>
        )) : <span style={{ fontSize: 12, color: '#6b7280' }}>📄 Brak dokumentów</span>}
        {msg ? <span style={{ fontSize: 11, color: msg.startsWith('✓') ? '#059669' : '#dc2626' }}>{msg}</span> : null}
      </div>
      <div style={{ marginBottom: 12 }}>
        <textarea value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Dodaj notatkę do zamówienia…" rows={2}
          style={{ width: '100%', boxSizing: 'border-box', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #bbf7d0', resize: 'vertical', fontFamily: 'inherit' }} />
        <button onClick={addNote} disabled={saving || !draft.trim()}
          style={{ marginTop: 6, fontSize: 13, fontWeight: 600, padding: '7px 16px', borderRadius: 8, border: 'none', background: (saving || !draft.trim()) ? '#86efac' : '#15803d', color: '#fff', cursor: (saving || !draft.trim()) ? 'default' : 'pointer' }}>
          {saving ? '⏳ Zapisuję…' : '+ Dodaj notatkę'}
        </button>
      </div>
      {(d.notes || []).length === 0 ? <div style={{ fontSize: 14, color: '#6b7280', padding: '10px 0', textAlign: 'center' }}>Brak notatek.</div> : null}
      {(d.notes || []).map((n: any) => (
        <div key={n.id} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px', marginBottom: 8, background: '#fff' }}>
          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 6 }}>{fmt(n.created_at)}{n.author_name ? ' • ' + n.author_name : ''}</div>
          <div style={{ fontSize: 13, color: '#111827', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{n.comment || '—'}</div>
        </div>
      ))}
    </div>
  );
}
